import { User } from "@auth0/auth0-react";

export function getRolesFromAuth0User(user: User): string[] {
  return user["https://normasteaching.com/roles"] ?? [];
}
